import { List, ReferenceInput, SelectField, SelectInput, SimpleList, TextInput } from "react-admin";
import { administrationRequests } from "api/administrationApi";
import { Datagrid, FunctionField, ReferenceField, TextField } from "react-admin";
import { MissingAttestationsPanel } from "./components/MissingAttestationsPanel";
import { MissingAttestationsMobilePanel } from "./components/MissingAttestationsMobilePanel";
import InterruptButton from "./components/InterruptButton";
import { CourseChoices, SemestersChoices } from "utils/choices";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { EmptyList } from "server/components";
import { settings } from "app";
import { useMediaQuery } from "@mui/material";
import { InterruptionsExporter } from "./XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { MobileListRow } from "features/MobileListRow";

const filters = [
  <TextInput
    label="Фак. №"
    source="facultyNumber"
    alwaysOn
  />,
  <ReferenceInput
    source="specialityId"
    reference={administrationRequests.getSpecialitiesSelect()}
    label="Специалност"
    alwaysOn
  >
    <SelectInput
      label="Специалност"
      emptyText="Всички"
      style={{ minWidth: 280 }}
    />
  </ReferenceInput>,
  <SelectInput
    source="currentCourse"
    label="Курс"
    choices={CourseChoices}
    alwaysOn
    emptyText={"Всички"}
  />,
  <SelectInput
    source="semester"
    label="Семестър"
    choices={SemestersChoices}
    alwaysOn
    emptyText={"Всички"}
  />,
];

const ListIncompleteSemesters = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <List
      title="Незаверени семестри"
      filters={filters}
      actions={<ExportXlsButton exporter={InterruptionsExporter} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => `${record.firstName} ${record.lastName}`}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Факултетен №", value: record.facultyNumber }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Курс",
                    value: (
                      <SelectField
                        source="currentCourse"
                        label="Курс"
                        choices={CourseChoices}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Семестър",
                    value: (
                      <SelectField
                        source="semester"
                        label="Семестър"
                        choices={SemestersChoices}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Специалност",
                    value: (
                      <ReferenceField
                        source="specialityId"
                        reference={administrationRequests.getSpecialitiesSelect()}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
              <MobileListRow
                fields={[
                  {
                    label: "Липсващи заверки",
                    value: record.attestations.length,
                  },
                ]}
              />
              <MissingAttestationsMobilePanel record={record} />
            </div>
          )}
          tertiaryText={record => `Липсващи заверки: ${record.attestations.length}`}
        />
      ) : (
        <Datagrid
          expand={MissingAttestationsPanel}
          bulkActionButtons={<InterruptButton />}
        >
          <TextField
            source="facultyNumber"
            label="Факултетен №"
          />
          <TextField
            source="firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="lastName"
            label="Фамилия"
            sortable={false}
          />
          <SelectField
            source="currentCourse"
            label="Курс"
            choices={CourseChoices}
          />
          <SelectField
            source="semester"
            label="Семестър"
            choices={SemestersChoices}
          />
          <ReferenceField
            source="specialityId"
            label="Специалност"
            reference={administrationRequests.getSpecialitiesSelect()}
          >
            <TextField
              label="Специалност"
              source="name"
            />
          </ReferenceField>
          <FunctionField
            render={record => record.attestations.length}
            label="Липсващи заверки"
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListIncompleteSemesters;
